import { AuthUser } from "@shared/types";
import { isWhitelabelSubscriptionType } from "@shared/utils/misc.ts";

type BrandingUser = Pick<AuthUser, "is_sub_user" | "subscription_plan_type">;

export const shouldFetchWhitelabelConfiguration = (
  user?: BrandingUser
): boolean =>
  !user ||
  user.is_sub_user ||
  isWhitelabelSubscriptionType(user.subscription_plan_type);
